import { AssetCardController } from './asset-card.controller'

function assetCard () {
  return {
    restrict: 'E',
    scope: {
      asset: '=',
      currentPage: '<',
      currentSection: '<',
      openPreview: '&',
      selectedAssets: '<',
      selectedFolders: '<',
      disabled: '<',
      disabledTooltipText: '@',
      visualization: '<',
      modalState: '<',
      assetIndex: '<',
      shouldDragCards: '<',
      pricing: '<',
      singleAttach: '<'
    },
    templateUrl: '/repository/directives/asset-card/asset-card-directive.html?$$REVISION$$',
    controller: AssetCardController
  }
}

export { assetCard }
